export enum FileReaderAvailability {
  EMPTY = 0, // 	Reader has been created. None of the read methods called yet.
  LOADING = 1, // A read method has been called.
  DONE = 2 // The operation is complete.
}
